import React, { useEffect } from 'react';
import { IItemForGetShortInfo, IGetSubCategoriesShort, IGetSubCategoriesArguments } from 'types';
import { useFetchData } from 'hooks/useFetchData';
import { getSubCategoriesShortInfoV2 } from 'backend/subcategories';
import FormSelect from 'components/Select/FormSelect';
import style from './SuggestedDishSubCategorySelect.module.scss';

interface IProps {
	setFetchedSuggestedDishSubCategories: (value: IItemForGetShortInfo[]) => void;
	setSuggestedDishSubCategory: (value: Nullable<string>) => void;
	selectedSuggestedDishCategory: Nullable<string>;
}

export const SuggestedDishSubCategorySelect: React.FC<IProps> = React.memo(
	({ setFetchedSuggestedDishSubCategories, setSuggestedDishSubCategory, selectedSuggestedDishCategory }) => {
		const { response, loading, refetch, responseError } = useFetchData<
			IGetSubCategoriesShort,
			IGetSubCategoriesArguments
		>(selectedSuggestedDishCategory ? getSubCategoriesShortInfoV2 : null, {
			categoryId: selectedSuggestedDishCategory ? selectedSuggestedDishCategory : '',
		});

		useEffect(() => {
			refetch();
		}, [selectedSuggestedDishCategory]);

		useEffect(() => {
			response && setFetchedSuggestedDishSubCategories(response.data.subCategories);
		}, [response]);

		return (
			<FormSelect
				name="selectedSuggestedDishSubCategory"
				label="subcategoryLabel"
				formItemClassName={style.container}
				options={response?.data.subCategories}
				fetchError={responseError}
				loading={loading}
				onRefetch={refetch}
				disabled={!selectedSuggestedDishCategory || loading}
				onChange={setSuggestedDishSubCategory}
				onMouseDown={(e) => e.stopPropagation()}
				onClick={(e) => e.stopPropagation()}
			/>
		);
	},
);
